var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FavoriteFoldersModal, FavoriteProvider, SaveFavoriteFolderModal, useWishlists, useFolderPicker, addFavorite as addFavoriteService, removeFavorite as removeFavoriteService, updateFavorite as updateFavoriteService } from '@homeexchange/home';
import { pushEventDataToDataLayer } from '@homeexchange/analytics';
import { useToast } from '@homeexchange/design';
import { addFavorite as addFavoriteAction, removeFavorite as removeFavoriteAction, fetchHomeFavorites } from '../actions/homeFavorites';
import { setQuickAddFolder, resetQuickAddFolder } from '../actions/quickAddFolder';
import i18n from '../i18n';
import { getDynamicUrl } from '../middleware/lokaliseUrlMiddleware';
import { selectSession } from '../selectors/session';
export var useFavoriteModals = function (options) {
    var _a = useState(false), isMoving = _a[0], setIsMoving = _a[1];
    var isMovingRef = useRef(false);
    var folderPickerRef = useRef(null);
    var prevResetKeyRef = useRef(options === null || options === void 0 ? void 0 : options.quickAddResetKey);
    var dispatch = useDispatch();
    var showToast = useToast().showToast;
    var session = useSelector(selectSession);
    var localeDescription = useSelector(function (state) { return state.localeDescription; });
    var homeFavorites = useSelector(function (state) { return state.homeFavorites || []; });
    var quickAddFolder = useSelector(function (state) { return ((options === null || options === void 0 ? void 0 : options.quickAdd) ? state.quickAddFolder : null); });
    useEffect(function () {
        if ((options === null || options === void 0 ? void 0 : options.quickAdd) && options.quickAddResetKey !== prevResetKeyRef.current) {
            prevResetKeyRef.current = options.quickAddResetKey;
            dispatch(resetQuickAddFolder());
        }
    }, [options === null || options === void 0 ? void 0 : options.quickAddResetKey]);
    var _b = useWishlists({ enabled: false, withUncategorized: false }), wishlists = _b.wishlists, loading = _b.loading, initialized = _b.initialized, createWishlist = _b.createWishlist, resolveWishlistIdForHome = _b.resolveWishlistIdForHome, patchWishlistForFavorite = _b.patchWishlistForFavorite, refetchWishlists = _b.refetchWishlists, loadMore = _b.loadMore, hasMore = _b.hasMore, isLoadingMore = _b.isLoadingMore;
    var config = {
        apiUrl: getDynamicUrl(process.env.URL_BFF),
        assetsUrl: process.env.URL_MIGRATION_ASSETS,
        locale: localeDescription,
        session: session
    };
    var handleSelect = useCallback(function (homeId, wishlistId, wishlistTitle) { return __awaiter(void 0, void 0, void 0, function () {
        var sourceWishlistId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMovingRef.current) return [3 /*break*/, 2];
                    if (options === null || options === void 0 ? void 0 : options.quickAdd) {
                        dispatch(setQuickAddFolder({ id: wishlistId, title: wishlistTitle }));
                    }
                    return [4 /*yield*/, resolveWishlistIdForHome(homeId)];
                case 1:
                    sourceWishlistId = _a.sent();
                    if (sourceWishlistId) {
                        patchWishlistForFavorite({
                            type: 'move',
                            sourceWishlistId: sourceWishlistId,
                            targetWishlistId: wishlistId,
                            homeId: homeId
                        });
                    }
                    showToast({
                        status: 'success',
                        text: i18n.t('home:toast_favorites_movedtofolder', {
                            folderName: wishlistTitle
                        }),
                        link: {
                            children: i18n.t('global:global_modify'),
                            onClick: function () {
                                isMovingRef.current = true;
                                setIsMoving(true);
                                folderPickerRef.current.openForHome(homeId, wishlistId);
                            }
                        }
                    });
                    updateFavoriteService({ homeId: homeId, wishlistId: wishlistId })
                        .then(function () {
                        if (options === null || options === void 0 ? void 0 : options.trackingArea) {
                            pushEventDataToDataLayer('change_favorite_folder', {
                                area: options.trackingArea
                            });
                        }
                    })
                        .catch(function (error) { return console.error('Error moving favorite:', error); });
                    return [3 /*break*/, 3];
                case 2:
                    if (options === null || options === void 0 ? void 0 : options.quickAdd) {
                        dispatch(setQuickAddFolder({ id: wishlistId, title: wishlistTitle }));
                    }
                    dispatch(addFavoriteAction(homeId));
                    patchWishlistForFavorite({ type: 'add', wishlistId: wishlistId, homeId: homeId });
                    showToast({
                        status: 'success',
                        text: i18n.t('home:toast_favorites_addedToFolder', { foldersName: wishlistTitle }),
                        link: {
                            children: i18n.t('global:global_modify'),
                            onClick: function () {
                                isMovingRef.current = true;
                                setIsMoving(true);
                                folderPickerRef.current.openForHome(homeId, wishlistId);
                            }
                        }
                    });
                    addFavoriteService({ homeId: homeId, wishlistId: wishlistId })
                        .then(function () {
                        if (options === null || options === void 0 ? void 0 : options.trackingArea) {
                            pushEventDataToDataLayer('add_a_favorite', {
                                text: "home_card_".concat(homeId),
                                area: options.trackingArea
                            });
                        }
                    })
                        .catch(function (error) { return console.error('Error adding favorite:', error); });
                    _a.label = 3;
                case 3:
                    isMovingRef.current = false;
                    setIsMoving(false);
                    dispatch(fetchHomeFavorites());
                    refetchWishlists();
                    return [2 /*return*/];
            }
        });
    }); }, [
        dispatch,
        resolveWishlistIdForHome,
        patchWishlistForFavorite,
        refetchWishlists,
        showToast,
        options === null || options === void 0 ? void 0 : options.trackingArea
    ]);
    var folderPicker = useFolderPicker({
        wishlists: wishlists,
        isLoadingWishlists: loading,
        wishlistsInitialized: initialized,
        mode: isMoving ? 'move' : 'add',
        onSelect: handleSelect,
        createWishlist: createWishlist,
        onFolderCreated: function () {
            if (options === null || options === void 0 ? void 0 : options.trackingArea) {
                pushEventDataToDataLayer('add_a_favorite_folder', { area: options.trackingArea });
            }
        },
        loadMore: loadMore,
        hasMore: hasMore,
        isLoadingMore: isLoadingMore
    });
    folderPickerRef.current = folderPicker;
    var handleAddFavorite = useCallback(function (homeId, prefillName) {
        isMovingRef.current = false;
        setIsMoving(false);
        if ((options === null || options === void 0 ? void 0 : options.quickAdd) && quickAddFolder) {
            var wishlistId_1 = quickAddFolder.id, wishlistTitle = quickAddFolder.title;
            dispatch(addFavoriteAction(homeId));
            patchWishlistForFavorite({ type: 'add', wishlistId: wishlistId_1, homeId: homeId });
            showToast({
                status: 'success',
                text: i18n.t('home:toast_favorites_addedToFolder', { foldersName: wishlistTitle }),
                link: {
                    children: i18n.t('global:global_modify'),
                    onClick: function () {
                        isMovingRef.current = true;
                        setIsMoving(true);
                        folderPicker.openForHome(homeId, wishlistId_1);
                    }
                }
            });
            addFavoriteService({ homeId: homeId, wishlistId: wishlistId_1 })
                .then(function () {
                if (options === null || options === void 0 ? void 0 : options.trackingArea) {
                    pushEventDataToDataLayer('add_a_favorite', {
                        text: "home_card_".concat(homeId),
                        area: options.trackingArea
                    });
                }
            })
                .catch(function (error) { return console.error('Error adding favorite:', error); });
            dispatch(fetchHomeFavorites());
            refetchWishlists();
            return;
        }
        folderPicker.openForHome(homeId, undefined, prefillName);
        resolveWishlistIdForHome(homeId).then(function (wishlistId) {
            if (wishlistId)
                folderPicker.setOverrideWishlistId(wishlistId);
        });
    }, [
        options === null || options === void 0 ? void 0 : options.quickAdd,
        options === null || options === void 0 ? void 0 : options.trackingArea,
        folderPicker,
        dispatch,
        patchWishlistForFavorite,
        refetchWishlists,
        showToast,
        resolveWishlistIdForHome
    ]);
    var handleRemoveFavorite = useCallback(function (homeId) {
        dispatch(removeFavoriteAction(homeId));
        showToast({
            status: 'success',
            text: i18n.t('home:toast_favorites_removed')
        });
        resolveWishlistIdForHome(homeId).then(function (wishlistId) {
            if (wishlistId) {
                patchWishlistForFavorite({ type: 'remove', wishlistId: wishlistId, homeId: homeId });
            }
        });
        removeFavoriteService({ homeId: homeId })
            .then(function () {
            if (options === null || options === void 0 ? void 0 : options.trackingArea) {
                pushEventDataToDataLayer('remove_a_favorite', { area: options.trackingArea });
            }
            dispatch(fetchHomeFavorites());
            refetchWishlists();
        })
            .catch(function (error) {
            console.error('Error removing favorite:', error);
            dispatch(fetchHomeFavorites());
            refetchWishlists();
        });
    }, [
        dispatch,
        showToast,
        resolveWishlistIdForHome,
        patchWishlistForFavorite,
        refetchWishlists,
        options === null || options === void 0 ? void 0 : options.trackingArea
    ]);
    var handleMoveFavorite = useCallback(function (homeId) {
        isMovingRef.current = true;
        setIsMoving(true);
        folderPicker.openForHome(homeId);
        resolveWishlistIdForHome(homeId).then(function (wishlistId) {
            if (wishlistId)
                folderPicker.setOverrideWishlistId(wishlistId);
        });
    }, [folderPicker, resolveWishlistIdForHome]);
    var handleFavoriteClick = useCallback(function (homeId, prefillName) {
        var homeIdNumber = typeof homeId === 'string' ? parseInt(homeId, 10) : homeId;
        if (homeFavorites.includes(homeIdNumber)) {
            handleRemoveFavorite(homeIdNumber);
        }
        else {
            handleAddFavorite(homeIdNumber, prefillName);
        }
    }, [homeFavorites, handleRemoveFavorite, handleAddFavorite]);
    var modals = (React.createElement(FavoriteProvider, { config: config },
        React.createElement(FavoriteFoldersModal, __assign({}, folderPicker.foldersModalProps)),
        React.createElement(SaveFavoriteFolderModal, __assign({}, folderPicker.createFolderModalProps))));
    return {
        handleFavoriteClick: handleFavoriteClick,
        handleAddFavorite: handleAddFavorite,
        handleRemoveFavorite: handleRemoveFavorite,
        handleMoveFavorite: handleMoveFavorite,
        modals: modals
    };
};
export default useFavoriteModals;
